import React from 'react';

export const PlayIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 5.14V19.14L19 12.14L8 5.14Z" fill="currentColor" />
  </svg>
);
